"use client";

import React from "react";
import { Eye, Pencil, Trash2, Download, ShieldBan } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const userRights = [{
  id: 1,
  title: "Diritto di Accesso",
  description: "Hai il diritto di ottenere la conferma che sia o meno in corso un trattamento di dati personali che ti riguardano e, in tal caso, di ottenere l'accesso ai dati personali in modo chiaro e trasparente.",
  icon: Eye
}, {
  id: 2,
  title: "Diritto di Rettifica",
  description: "Puoi richiedere la rettifica dei dati personali inesatti che ti riguardano o l'integrazione dei dati personali incompleti, garantendo che le tue informazioni siano sempre aggiornate.",
  icon: Pencil
}, {
  id: 3,
  title: "Diritto alla Cancellazione",
  description: "Hai il diritto di ottenere la cancellazione dei dati personali che ti riguardano senza ingiustificato ritardo, noto anche come 'diritto all'oblio', nel rispetto delle normative vigenti.",
  icon: Trash2
}, {
  id: 4,
  title: "Diritto alla Portabilità",
  description: "Puoi ricevere in un formato strutturato, di uso comune e leggibile da dispositivo automatico i dati personali che ti riguardano per trasmetterli a un altro titolare del trattamento.",
  icon: Download
}, {
  id: 5,
  title: "Diritto di Opposizione",
  description: "Hai il diritto di opporti in qualsiasi momento al trattamento dei dati personali che ti riguardano per motivi connessi alla tua situazione particolare, inclusa la profilazione.",
  icon: ShieldBan
}];
export default function UserRights() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="diritti-degli-utenti" className="bg-background py-24 md:py-32">
      <div ref={ref} className={`container mx-auto px-4 max-w-4xl transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16">
          <h2 className="font-default text-3xl md:text-4xl font-semibold text-foreground mb-4">
            I Tuoi Diritti
          </h2>
          <p className="font-sans text-muted-foreground max-w-2xl mx-auto">
            La trasparenza e il controllo sui tuoi dati sono la nostra priorità. Ecco i diritti fondamentali che ti garantiamo in ogni momento.
          </p>
        </div>

        <div className="flex flex-col gap-6">
          {userRights.map((right, i) => {
          const Icon = right.icon;
          return <Card key={right.id} data-index={i} className="rounded-sm shadow-sm border-border/40 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-md hover:border-ring/30 group overflow-hidden bg-card">
                <div className="flex flex-col sm:flex-row items-start sm:items-center p-6 sm:p-8 gap-6 sm:gap-8">
                  <div className="shrink-0 flex items-center justify-center w-16 h-16 rounded-full bg-background border border-border/50 group-hover:border-ring/20 transition-colors duration-500">
                    <Icon className="w-8 h-8 text-ring transition-transform duration-500 group-hover:scale-110" strokeWidth={1.2} />
                  </div>
                  <div>
                    <h3 className="font-default text-xl font-semibold text-foreground mb-2">
                      {right.title}
                    </h3>
                    <p className="font-sans text-muted-foreground leading-relaxed">
                      {right.description}
                    </p>
                  </div>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}